import * as React from 'react';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Card } from '@mui/material';

const TitleGrid = (props) => {
  const backgroundColor = props.backgroundColor;
  const paddingTop = props.paddingTop;
  const paddingBottom = props.paddingBottom;
  const paddingLeft = props.paddingLeft;
  const paddingRight = props.paddingRight;
  const padding = props.padding;
  const marginTop = props.marginTop;
  const marginBottom = props.marginBottom;
  const marginLeft = props.marginLeft;
  const marginRight = props.marginRight;
  const textColor = props.textColor;
  const title2TextColor = props.title2TextColor;
  const border = props.border;
  const borderRadius = props.borderRadius;

  const widthRate = parseFloat(props.widthRate);
  const height = parseFloat(props.height);
  const title = props.title;
  const title2 = props.title2;
  const titleFontSize = props.titleFontSize;
  const title2FontSize = props.title2FontSize;
  const haveCard = props.haveCard;

  return (
    <Grid item xs={widthRate == null ? 10.5 : widthRate}>
      {haveCard == null ? (
        <Box
          sx={{
            height: height == null ? '100%' : height,
            paddingTop: paddingTop == null ? 1 : paddingTop,
            paddingBottom: paddingBottom == null ? 0 : paddingBottom,
            paddingLeft: paddingLeft == null ? 0 : paddingLeft,
            paddingRight: paddingRight == null ? 0 : paddingRight,
            marginTop: marginTop == null ? 0 : marginTop,
            marginBottom: marginBottom == null ? 0 : marginBottom,
            marginLeft: marginLeft == null ? 0 : marginLeft,
            marginRight: marginRight == null ? 0 : marginRight,
            backgroundColor:
              backgroundColor == null ? '#2e4665' : backgroundColor,
            padding: padding == null ? 0 : padding,
            border: border == null ? 0 : border,
            borderRadius: borderRadius == null ? 0 : borderRadius,
          }}
        >
          <Typography
            variant={titleFontSize != null ? titleFontSize : 'h5'}
            color={textColor == null ? 'white' : textColor}
          >
            {title}
          </Typography>
          {title2 != null ? (
            <Typography
              variant={
                title2FontSize != null
                  ? title2FontSize
                  : titleFontSize != null
                    ? titleFontSize
                    : 'h5'
              }
              color={
                title2TextColor == null
                  ? textColor != null
                    ? textColor
                    : 'white'
                  : title2TextColor
              }
            >
              {title2}
            </Typography>
          ) : (
            ''
          )}
        </Box>
      ) : (
        <Card style={{ height: '100%' }}>
          <Box
            sx={{
              height: '100%',
              paddingTop: paddingTop == null ? 1 : paddingTop,
              paddingBottom: paddingBottom == null ? 0 : paddingBottom,
              paddingLeft: paddingLeft == null ? 0 : paddingLeft,
              paddingRight: paddingRight == null ? 0 : paddingRight,
              marginTop: marginTop == null ? 0 : marginTop,
              marginBottom: marginBottom == null ? 0 : marginBottom,
              marginLeft: marginLeft == null ? 0 : marginLeft,
              marginRight: marginRight == null ? 0 : marginRight,
              backgroundColor:
                backgroundColor == null ? '#2e4665' : backgroundColor,
            }}
          >
            <Typography
              variant={titleFontSize != null ? titleFontSize : 'h5'}
              color={textColor == null ? 'white' : textColor}
            >
              {title}
            </Typography>
            {title2 != null ? (
              <Typography
                variant={
                  title2FontSize != null
                    ? title2FontSize
                    : titleFontSize != null
                      ? titleFontSize
                      : 'h5'
                }
                color={
                  title2TextColor == null
                    ? textColor != null
                      ? textColor
                      : 'white'
                    : title2TextColor
                }
              >
                {title2}
              </Typography>
            ) : (
              ''
            )}
          </Box>
        </Card>
      )}
    </Grid>
  );
};

export default TitleGrid;
